export default __webpack_public_path__ + "static/media/circles-no-7.0e6df8b6.mid";